import React from 'react'

const SectionHeader = ({title}) => {
  return (
    <div className='flex flex-col items-center p-[36px_0] '>
        <p className='text-white font-semibold text-[56px] border-b-[2px] border-purple max-[500px]:text-[40px]'>{title}</p>
    </div>
  )
}

export default SectionHeader